import { Component, Input } from '@angular/core';
import { LICENSE_PRODUCT_SEAT_TYPES } from 'go-modules/services/group/product';
import { NgxPurchaseTypeService } from '@go-modules/services/purchase-type/purchase-type.service';
import type { Product } from 'go-modules/services/group/product';
import type { cardPaymentMethodPayload } from 'braintree-web-drop-in';
import type { LicenseDetailsForm } from '@go-modules/interfaces/licenses/license-details-form';
import type { Group } from '@go-modules/interfaces/groups/group.interface';
import type { TaxEstimate } from 'go-modules/models/avalara/avalara.service';
import type { PaymentOptionsModalData } from 'go-modules/payment-panel/payment-panel.controller';
import { Address } from '@go-modules/services/address-details-form/address-details-form.service';

@Component({
	selector: 'review-payment',
	templateUrl: 'review-payment.component.html',
	styleUrls: ['./review-payment.component.scss'],
	standalone: false
})
export class ReviewPaymentComponent {
	@Input() public paymentMethod: cardPaymentMethodPayload;
	@Input() public product: Product;
	@Input() public group: Group;
	@Input() public options: PaymentOptionsModalData;
	@Input() public licenseDetails: LicenseDetailsForm;
	@Input() public address: Address;
	@Input() public taxEstimate: TaxEstimate;

	constructor (
		public ngxPurchaseTypeService: NgxPurchaseTypeService
	) {
	}

	public get licenseTypeTranslationKey (): string {
		return this.licenseDetails.selectedProduct.licenseProduct.seat_type === LICENSE_PRODUCT_SEAT_TYPES.USER ?
			'payment-panel-license-details_license-type-multi-course' :
			'payment-panel-license-details_license-type-single-course';
	}

	public shouldShowProrate (): boolean {
		return this.licenseDetails && this.licenseDetails.prorateAdjustment != null;
	}

	public parseTotal (total: string): number {
		return parseFloat(total.replace(/,/g, ''));
	}
}
